// export const apiUrl = '/api/'
export const apiUrl = 'https://muzeumkomunikacji.pl/api/'
export const googleAnalyticsID = 'UA-XXX-X'
